import React from "react";

const Loader = () => {
  return (
    <div id="pre-load">
      <div id="loader" className="loader">
        <div className="loader-container">
          <div className="loader-icon">
            <img src="/assets/images/favicon.png" alt="" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Loader;
